import type { BootData } from '@/types/boot';
import { getBoot } from '@/utils/boot';
import { useEffect, useState } from 'react';
import { useErrorBoundary } from 'react-error-boundary';

export const useGetBoot = () => {
  const [boot, setBoot] = useState<BootData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const { showBoundary } = useErrorBoundary();

  useEffect(() => {
    getBoot()
      .then((boot) => {
        setBoot(boot);
        setIsLoading(false);
      })
      .catch(() => {
        showBoundary('unableToOpenCheckout');
      });
  }, []);

  const updateBoot = (newBoot: BootData) => {
    setBoot(newBoot);
  };

  return {
    boot,
    setBoot: updateBoot,
    isLoading,
  };
};
